// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Allow this page to span the full width */
.full-width-container {
  width: 100%;
  margin: 0;
  padding: 2rem 1rem;
}

.jobsverwaltung-wrapper {
  padding: 2rem 1rem;
  background-color: var(--blassgruen);
  border-radius: 10px;
  text-align: center;
  font-family: 'Circular', sans-serif;
  font-weight: normal;
}

.jobsverwaltung-wrapper h1 {
  font-size: 2.2rem;
  color: var(--mittelblau);
  margin-bottom: 1.5rem;
}

.jobs-suche-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 400px;
  margin: 0 auto 2rem auto;
}

.jobs-suche-wrapper::after {
  content: "";
  position: absolute;
  left: 40px;
  right: 10px;
  bottom: 23px;
  height: 2px;
  background-color: var(--dunkelgruen);
}

.jobs-suche-wrapper input[type="text"] {
  width: 100%;
  padding: 5px 0 5px 40px;
  font-size: 1rem;
  border: none;
  border-radius: 0;
  outline: none;
  background-color: transparent;
  box-shadow: none;
  color: var(--dunkelgruen);
}

.jobs-suche-wrapper input[type="text"]::placeholder {
  color: var(--hellgruen);
  font-size: 1.2em;
}

.search-icon {
  position: absolute;
  left: 0;
  top: calc(50% - 8px);
  transform: translateY(-50%);
  pointer-events: none;
  color: var(--dunkelgruen);
  font-family: 'Material Symbols Outlined';
  font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 40;
  font-size: 30px;
}


.job-name {
  font-weight: normal;
  color: var(--dunkelgruen);
}

.slot-input {
  width: 60px;
  padding: 6px;
  border: 1px solid #aaa;
  border-radius: 6px;
  font-size: 1rem;
  text-align: center;
  background-color: var(--weiss);
  color: #333;
}

.summary-row {
  background-color: var(--weiss);
  font-family: 'Circular', sans-serif;
  font-weight: normal;
}

.jobbutton {
  display: inline-block;
  padding: 1rem 1rem;
  font-size: 1.4rem;
  font-family: 'Staatliches', sans-serif;
  font-weight: normal;
  color: var(--weiss);
  background-color: var(--dunkelgruen);
  border: none;
  border-radius: 20px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  line-height: 1.2;
  min-height: 60px;
  position: sticky;
  top: 0.5rem;
  z-index: 5;
  margin-bottom: 1rem;
}

.jobbutton:hover {
  background-color: #5a7502;
}

.slot-cell {
  position: relative;
}

.slot-input-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.warning-icon {
  color: #d9534f;
  margin-left: 5px;
  font-size: 20px;
  cursor: help;
}`, "",{"version":3,"sources":["webpack://./src/arbeit/jobsverwaltung/JobsVerwaltung.css"],"names":[],"mappings":"AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,oBAAoB;EACpB,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;EACzB,wCAAwC;EACxC,kEAAkE;EAClE,eAAe;AACjB;;;AAGA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,6CAA6C;EAC7C,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd","sourcesContent":["@import '../../styles/variables.css';\n\n/* Allow this page to span the full width */\n.full-width-container {\n  width: 100%;\n  margin: 0;\n  padding: 2rem 1rem;\n}\n\n.jobsverwaltung-wrapper {\n  padding: 2rem 1rem;\n  background-color: var(--blassgruen);\n  border-radius: 10px;\n  text-align: center;\n  font-family: 'Circular', sans-serif;\n  font-weight: normal;\n}\n\n.jobsverwaltung-wrapper h1 {\n  font-size: 2.2rem;\n  color: var(--mittelblau);\n  margin-bottom: 1.5rem;\n}\n\n.jobs-suche-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  max-width: 400px;\n  margin: 0 auto 2rem auto;\n}\n\n.jobs-suche-wrapper::after {\n  content: \"\";\n  position: absolute;\n  left: 40px;\n  right: 10px;\n  bottom: 23px;\n  height: 2px;\n  background-color: var(--dunkelgruen);\n}\n\n.jobs-suche-wrapper input[type=\"text\"] {\n  width: 100%;\n  padding: 5px 0 5px 40px;\n  font-size: 1rem;\n  border: none;\n  border-radius: 0;\n  outline: none;\n  background-color: transparent;\n  box-shadow: none;\n  color: var(--dunkelgruen);\n}\n\n.jobs-suche-wrapper input[type=\"text\"]::placeholder {\n  color: var(--hellgruen);\n  font-size: 1.2em;\n}\n\n.search-icon {\n  position: absolute;\n  left: 0;\n  top: calc(50% - 8px);\n  transform: translateY(-50%);\n  pointer-events: none;\n  color: var(--dunkelgruen);\n  font-family: 'Material Symbols Outlined';\n  font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 40;\n  font-size: 30px;\n}\n\n\n.job-name {\n  font-weight: normal;\n  color: var(--dunkelgruen);\n}\n\n.slot-input {\n  width: 60px;\n  padding: 6px;\n  border: 1px solid #aaa;\n  border-radius: 6px;\n  font-size: 1rem;\n  text-align: center;\n  background-color: var(--weiss);\n  color: #333;\n}\n\n.summary-row {\n  background-color: var(--weiss);\n  font-family: 'Circular', sans-serif;\n  font-weight: normal;\n}\n\n.jobbutton {\n  display: inline-block;\n  padding: 1rem 1rem;\n  font-size: 1.4rem;\n  font-family: 'Staatliches', sans-serif;\n  font-weight: normal;\n  color: var(--weiss);\n  background-color: var(--dunkelgruen);\n  border: none;\n  border-radius: 20px;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n  line-height: 1.2;\n  min-height: 60px;\n  position: sticky;\n  top: 0.5rem;\n  z-index: 5;\n  margin-bottom: 1rem;\n}\n\n.jobbutton:hover {\n  background-color: #5a7502;\n}\n\n.slot-cell {\n  position: relative;\n}\n\n.slot-input-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.warning-icon {\n  color: #d9534f;\n  margin-left: 5px;\n  font-size: 20px;\n  cursor: help;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
